import { images } from '../constants';

const products = [
    {
        id: 1,
        image: images.product1Gallery1,
        name: "Chicken Burger",
        price: 9.99,
        disprice: 7.99,
        stock: 10,
        content: "Bite into our tender chicken burger, featuring a perfectly grilled chicken patty, fresh lettuce, tomatoes, and our tangy sauce, all nestled in a soft toasted bun. A delightful alternative to the classic beef burger, packed with savory flavors and crispy textures.",
        description: "Our Chicken Burger is a flavorful option, combining a juicy grilled chicken patty with fresh veggies and our signature sauce. Perfect for anyone seeking a lighter yet satisfying meal, with a mix of tenderness and crunch in every bite.",
        category: ["Fast Food"],
        tags: ["burger", "beef", "dessert"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "Chicken, Lettuce, Tomatoes, Bun, Tangy Sauce" },
            { id: 2, title: "Weight", content: "230 grams" }
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "Alice Brown",
                date: "Jul 5, 2024",
                rating: 5,
                content: "A delicious chicken burger! The patty was juicy, and the sauce was perfect."
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "Mark Lee",
                date: "Jun 28, 2024",
                rating: 5,
                content: "Incredible taste! Definitely my new favorite burger."
            }
        ]
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: "Spring Rolls",
        price: 5.99,
        disprice: 4.49,
        stock: 5,
        content: "Crispy on the outside and packed with savory fillings, our spring rolls are the perfect appetizer. Each roll is filled with a delightful mix of vegetables and seasoning, fried to golden perfection and served with a tangy dipping sauce.",
        description: "Our Spring Rolls offer a crispy, satisfying snack that’s perfect for any occasion. Made with fresh vegetables and seasoned to perfection, these rolls are fried until golden and served with a flavorful dipping sauce for an extra kick.",
        category: ["Healthy Meals"],
        tags: ["rolls", "chicken", "snack"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "Cabbage, Carrots, Rice Paper, Soy Sauce, Dipping Sauce" },
            { id: 2, title: "Weight", content: "150 grams" }
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "Linda Green",
                date: "Jul 7, 2024",
                rating: 5,
                content: "These spring rolls were perfectly crispy and full of flavor! Highly recommend."
            },
            {
                id: 2,
                image: images.product2Review2,
                name: "John Wilson",
                date: "Jun 25, 2024",
                rating: 4,
                content: "Delicious and crispy, but a bit too much soy sauce for my taste."
            }
        ]
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Chocolate Cake",
        price: 12.99,
        disprice: 10.99,
        stock: 8,
        content: "Indulge in our rich and decadent chocolate cake, made with premium cocoa and layered with smooth, velvety chocolate frosting. Each slice is a perfect balance of sweetness and richness, offering a heavenly experience for any chocolate lover.",
        description: "Our Chocolate Cake is a true indulgence, crafted with the finest ingredients to create a moist and tender texture. Covered with a luscious chocolate frosting, it’s the ultimate treat for those who love all things chocolate.",
        category: ["Dessert Items"],
        tags: ["cake", "dessert", "chocolate"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "Cocoa, Flour, Eggs, Butter, Chocolate Frosting" },
            { id: 2, title: "Weight", content: "350 grams" }
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: "Sophia Taylor",
                date: "Jul 10, 2024",
                rating: 5,
                content: "The best chocolate cake I’ve ever had! Rich, moist, and perfectly sweet."
            },
            {
                id: 2,
                image: images.product3Review2,
                name: "David Clark",
                date: "Jun 30, 2024",
                rating: 5,
                content: "A must-try for chocolate lovers. So rich and decadent!"
            }
        ]
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "Chicken Wings",
        price: 11.99,
        disprice: 9.99,
        stock: 0,
        content: "Savor our crispy and tender chicken wings, perfectly seasoned with a blend of spices and grilled to perfection. Whether you like them mild or spicy, our wings offer the ideal balance of crunch and juiciness in every bite.",
        description: "Our Chicken Wings are a crowd favorite, featuring succulent pieces of chicken with a crispy exterior and tender, juicy meat inside. Seasoned with a mix of bold spices, they are the ultimate snack for any occasion.",
        category: ["Fast Food"],
        tags: ["chicken", "wings", "snack"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "Chicken, Spices, Oil, Sauce" },
            { id: 2, title: "Weight", content: "300 grams" }
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "Emily Johnson",
                date: "Jul 15, 2024",
                rating: 5,
                content: "Best wings I've ever tasted! Crispy, juicy, and perfectly seasoned."
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "Chris Miller",
                date: "Jun 20, 2024",
                rating: 5,
                content: "These wings are amazing! A perfect balance of flavor and texture."
            }
        ]
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "Coffee",
        price: 4.99,
        disprice: 3.99,
        stock: 20,
        content: "Start your day with our rich and aromatic coffee, brewed to perfection from the finest beans. Whether you prefer it hot or iced, our coffee delivers a bold and satisfying flavor that will keep you energized throughout the day.",
        description: "Our Coffee is made with premium beans, expertly roasted and brewed for a full-bodied, smooth taste. Perfect for coffee enthusiasts who appreciate a classic cup of joe or those looking for a refreshing iced coffee on a hot day.",
        category: ["Beverage Drinks"],
        tags: ["coffee", "dessert", "hot"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "Coffee Beans, Water" },
            { id: 2, title: "Weight", content: "250 ml" }
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: "David Green",
                date: "Jul 10, 2024",
                rating: 5,
                content: "A perfect cup of coffee! Rich and full of flavor, just the way I like it."
            },
            {
                id: 2,
                image: images.product5Review2,
                name: "Sophia Black",
                date: "Jun 25, 2024",
                rating: 5,
                content: "Absolutely love this coffee. It’s strong and smooth – the perfect morning pick-me-up."
            }
        ]
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "Smoothies",
        price: 5.99,
        disprice: 4.99,
        stock: 9,
        content: "Refreshing and nutritious, our smoothies are made with fresh fruits and natural ingredients, blended to perfection. Whether you crave something tropical or a berry blend, each smoothie is a healthy and delicious way to quench your thirst.",
        description: "Our Smoothies are made with a variety of fresh fruits, such as mango, strawberry, and banana, combined with yogurt or almond milk for a creamy, refreshing treat. The perfect choice for a healthy snack or a post-workout boost.",
        category: ["Beverage Drinks"],
        tags: ["smoothie", "dessert", "fruit"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "Fruits, Yogurt, Almond Milk" },
            { id: 2, title: "Weight", content: "350 ml" }
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "Olivia White",
                date: "Jul 12, 2024",
                rating: 5,
                content: "This smoothie is so refreshing! The fruit blend is perfect, and it's not too sweet."
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "Ethan Grey",
                date: "Jun 30, 2024",
                rating: 5,
                content: "I love the texture and taste of these smoothies. Definitely my go-to for a quick snack!"
            }
        ]
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "Grilled Salmon",
        price: 15.99,
        disprice: 12.99,
        stock: 2,
        content: "Our Grilled Salmon is a rich, flavorful dish made from fresh, sustainably sourced salmon, perfectly grilled to enhance its natural taste. Served with a side of seasonal vegetables and a zesty lemon butter sauce, it’s a healthy and satisfying meal.",
        description: "This Grilled Salmon features tender, flaky fish that is lightly seasoned and grilled to perfection. Paired with a lemon butter sauce and a side of grilled vegetables, it's the perfect option for anyone looking for a nutritious and delicious meal.",
        category: ["Seafood Dishes"],
        tags: ["salmon", "seafood", "grilled"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "Salmon, Lemon, Butter, Vegetables" },
            { id: 2, title: "Weight", content: "200 grams" }
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "Lucas Green",
                date: "Jul 8, 2024",
                rating: 5,
                content: "Absolutely delicious! The salmon was perfectly grilled and the sauce was amazing."
            },
            {
                id: 2,
                image: images.product7Review2,
                name: "Sophia Blue",
                date: "Jun 25, 2024",
                rating: 5,
                content: "A fantastic dish! The flavors were spot on, and the salmon was so tender."
            }
        ]
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "Caesar Salad",
        price: 7.99,
        disprice: 6.49,
        stock: 0,
        content: "Our Caesar Salad features crisp romaine lettuce, freshly baked croutons, and creamy Caesar dressing, topped with shaved Parmesan cheese. A perfect balance of rich and tangy flavors, ideal as a side dish or a light main course.",
        description: "A classic favorite, our Caesar Salad is made with fresh romaine lettuce, crispy croutons, and drizzled with a rich, creamy Caesar dressing. Topped with grated Parmesan cheese, it’s a satisfying and flavorful option for anyone craving something light yet indulgent.",
        category: ["Healthy Meals"],
        tags: ["salad", "chicken", "healthy"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "Romaine Lettuce, Croutons, Caesar Dressing, Parmesan Cheese" },
            { id: 2, title: "Weight", content: "180 grams" }
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: "Emily Stone",
                date: "Jul 10, 2024",
                rating: 5,
                content: "The best Caesar Salad I’ve ever had! The dressing was perfect, and the croutons added the right amount of crunch."
            },
            {
                id: 2,
                image: images.product8Review2,
                name: "James Clark",
                date: "Jun 22, 2024",
                rating: 5,
                content: "Great salad! Fresh ingredients and the perfect amount of dressing."
            }
        ]
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "Cheese Cake",
        price: 6.99,
        disprice: 5.49,
        stock: 9,
        content: "Indulge in our rich and creamy cheesecake, made with a smooth, velvety cream cheese filling, and a buttery, crumbly graham cracker crust. Topped with fresh berries or fruit sauce for an extra touch of sweetness and flavor.",
        description: "Our Cheese Cake is a decadent dessert featuring a silky cream cheese filling with a perfect balance of sweetness and tang. Set atop a buttery graham cracker crust and topped with fresh berries or a drizzle of fruit sauce, it’s the ideal treat to satisfy your sweet cravings.",
        category: ["Dessert Items"],
        tags: ["cake", "cheese", "dessert"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "Cream Cheese, Sugar, Eggs, Graham Cracker, Butter, Fresh Berries" },
            { id: 2, title: "Weight", content: "200 grams" }
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: "Sophia Adams",
                date: "Jul 12, 2024",
                rating: 5,
                content: "The cheesecake was absolutely divine! Creamy and not too sweet—just perfect."
            },
            {
                id: 2,
                image: images.product9Review2,
                name: "Liam Turner",
                date: "Jun 18, 2024",
                rating: 5,
                content: "Best cheesecake I’ve ever had! I love the fresh berry topping—it added a nice tartness."
            }
        ]
    },
    {
        id: 10,
        image: images.product10Gallery1,
        name: "Beef Burger",
        price: 10.99,
        disprice: 8.99,
        stock: 10,
        content: "Enjoy our classic beef burger made with premium beef, fresh lettuce, tomatoes, and a special sauce, all served on a toasted bun. A perfect combination of savory flavors, crispy textures, and juicy beef that will satisfy your hunger.",
        description: "Indulge in our Classic Beef Burger, featuring a juicy beef patty, fresh lettuce, ripe tomatoes, and our signature sauce. Perfect for any meal, this burger offers a satisfying blend of flavors with every bite.",
        category: ["Fast Food"],
        tags: ["burger", "beef", "meal"],
        gallery: {
            image1: images.product10Gallery1,
            image2: images.product10Gallery2,
            image3: images.product10Gallery3,
            image4: images.product10Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "Beef, Lettuce, Tomatoes, Bun, Special Sauce" },
            { id: 2, title: "Weight", content: "250 grams" }
        ],
        comments: [
            {
                id: 1,
                image: images.product10Review1,
                name: "John Doe",
                date: "Jul 1, 2024",
                rating: 5,
                content: "One of the best burgers I've ever had! Juicy and flavorful."
            },
            {
                id: 2,
                image: images.product10Review2,
                name: "Jane Smith",
                date: "Jun 30, 2024",
                rating: 5,
                content: "Absolutely delicious! Highly recommend it to all burger lovers."
            }
        ]
    },
    {
        id: 11,
        image: images.product11Gallery1,
        name: "Spring Rolls",
        price: 5.99,
        disprice: 4.99,
        stock: 20,
        content: "Crispy and golden brown, our spring rolls are filled with a delicious mix of fresh vegetables and savory seasoning, offering a delightful crunch with every bite. Perfect as a snack or appetizer, served with a tangy dipping sauce.",
        description: "Enjoy our fresh and crispy Spring Rolls, filled with a blend of crunchy vegetables, all wrapped in a light, crispy pastry shell. These are a perfect appetizer or light snack, offering a great balance of flavor and texture.",
        category: ["Healthy Meals"],
        tags: ["rolls", "chicken", "snack"],
        gallery: {
            image1: images.product11Gallery1,
            image2: images.product11Gallery2,
            image3: images.product11Gallery3,
            image4: images.product11Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "Cabbage, Carrot, Bean Sprouts, Pastry" },
            { id: 2, title: "Weight", content: "120 grams" }
        ],
        comments: [
            {
                id: 1,
                image: images.product11Review1,
                name: "Emily White",
                date: "Jul 10, 2024",
                rating: 5,
                content: "The perfect appetizer! Crispy and full of flavor."
            },
            {
                id: 2,
                image: images.product11Review2,
                name: "David Green",
                date: "Jul 8, 2024",
                rating: 4,
                content: "A delicious snack. I love the crispy texture and fresh filling."
            }
        ]
    },
    {
        id: 12,
        image: images.product12Gallery1,
        name: "Chocolate Cake",
        price: 6.99,
        disprice: 5.99,
        stock: 25,
        content: "Indulge in the rich, velvety goodness of our chocolate cake, made with layers of moist chocolate sponge and topped with a decadent, smooth chocolate ganache. Perfect for dessert lovers who crave a sweet, satisfying treat.",
        description: "Our Chocolate Cake is a heavenly dessert, crafted with the finest cocoa and topped with a rich chocolate frosting. This moist, decadent cake is perfect for celebrating special occasions or enjoying with a cup of coffee.",
        category: ["Dessert Items"],
        tags: ["cake", "dessert", "chocolate"],
        gallery: {
            image1: images.product12Gallery1,
            image2: images.product12Gallery2,
            image3: images.product12Gallery3,
            image4: images.product12Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "Cocoa, Flour, Sugar, Butter, Eggs" },
            { id: 2, title: "Weight", content: "300 grams" }
        ],
        comments: [
            {
                id: 1,
                image: images.product12Review1,
                name: "Sophia Turner",
                date: "Jul 12, 2024",
                rating: 5,
                content: "The best chocolate cake I've ever had! So rich and moist."
            },
            {
                id: 2,
                image: images.product12Review2,
                name: "Ethan Mitchell",
                date: "Jul 7, 2024",
                rating: 5,
                content: "Absolutely delicious! A perfect treat for any chocolate lover."
            }
        ]
    },
    {
        id: 13,
        image: images.product13Gallery1,
        name: "Chicken Wings",
        price: 8.99,
        disprice: 7.49,
        stock: 30,
        content: "Savor the crispy, juicy goodness of our chicken wings, coated in a flavorful blend of spices and served with a side of tangy dipping sauce. Perfectly fried to golden perfection, these wings are a crowd favorite at any gathering.",
        description: "Our Chicken Wings are crispy on the outside and tender on the inside, offering a delightful crunch with every bite. Tossed in your choice of sauce, these wings are ideal for snack time, parties, or a satisfying meal.",
        category: ["Fast Food"],
        tags: ["chicken", "wings", "hot"],
        gallery: {
            image1: images.product13Gallery1,
            image2: images.product13Gallery2,
            image3: images.product13Gallery3,
            image4: images.product13Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "Chicken, Spices, Dipping Sauce" },
            { id: 2, title: "Weight", content: "200 grams" }
        ],
        comments: [
            {
                id: 1,
                image: images.product13Review1,
                name: "Michael Johnson",
                date: "Jul 10, 2024",
                rating: 5,
                content: "These wings are amazing! Crispy and packed with flavor."
            },
            {
                id: 2,
                image: images.product13Review2,
                name: "Olivia Martinez",
                date: "Jul 3, 2024",
                rating: 5,
                content: "Perfectly cooked, crispy, and juicy. Definitely coming back for more!"
            }
        ]
    },
    {
        id: 14,
        image: images.product14Gallery1,
        name: "Hot Coffee",
        price: 3.99,
        disprice: 2.99,
        stock: 50,
        content: "Start your day with our rich and aromatic hot coffee, brewed to perfection with freshly ground beans. Whether you prefer a bold espresso or a smooth latte, our hot coffee provides the perfect boost to your morning routine.",
        description: "Our Hot Coffee is made with premium coffee beans and expertly brewed to deliver a rich, full-bodied flavor. Whether you prefer it black or with cream and sugar, each cup offers a warm and comforting experience.",
        category: ["Beverage Drinks"],
        tags: ["coffee", "hot", "drink"],
        gallery: {
            image1: images.product14Gallery1,
            image2: images.product14Gallery2,
            image3: images.product14Gallery3,
            image4: images.product14Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "Coffee Beans, Water, Milk (Optional)" },
            { id: 2, title: "Weight", content: "250 grams" }
        ],
        comments: [
            {
                id: 1,
                image: images.product14Review1,
                name: "Daniel Green",
                date: "Jul 12, 2024",
                rating: 5,
                content: "A perfect cup of coffee! Strong and flavorful, just what I needed."
            },
            {
                id: 2,
                image: images.product14Review2,
                name: "Sophia White",
                date: "Jul 8, 2024",
                rating: 5,
                content: "This is the best coffee I've had in a while. Smooth and satisfying!"
            }
        ]
    },
    {
        id: 15,
        image: images.product15Gallery1,
        name: "Fruit Smoothie",
        price: 5.99,
        disprice: 4.49,
        stock: 30,
        content: "Refresh yourself with our vibrant fruit smoothie, made with a blend of fresh, seasonal fruits, and a splash of juice for a revitalizing taste. A perfect balance of sweet and tangy, this smoothie is packed with vitamins and energy.",
        description: "Our Fruit Smoothie is a delicious and healthy drink made with a variety of fresh fruits like strawberries, bananas, and mangoes. It's a great option for a nutritious snack or a post-workout boost.",
        category: ["Beverage Drinks"],
        tags: ["smoothie", "fruit", "drink"],
        gallery: {
            image1: images.product15Gallery1,
            image2: images.product15Gallery2,
            image3: images.product15Gallery3,
            image4: images.product15Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "Bananas, Strawberries, Mangoes, Orange Juice" },
            { id: 2, title: "Weight", content: "300 grams" }
        ],
        comments: [
            {
                id: 1,
                image: images.product15Review1,
                name: "Emma Davis",
                date: "Jul 10, 2024",
                rating: 5,
                content: "This smoothie is so refreshing! The blend of fruits is perfect, and it's not too sweet."
            },
            {
                id: 2,
                image: images.product15Review2,
                name: "Oliver Clark",
                date: "Jul 3, 2024",
                rating: 5,
                content: "Love the flavors in this smoothie! It's my go-to drink after a workout."
            }
        ]
    }
];

export default products;